import "./profile.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useContext } from 'react'
import { UserContext } from "../../context/AuthContext";


function Profile() {
    let { user } = useContext(UserContext)
    return (
        <div className="single">
            <Sidebar />
            <div className="singleContainer">
                <Navbar />
                <div>
                    <div className="top">
                        <div className="left">
                            <h1 className="title">Profile information</h1>
                            <div className="item">

                                <div className="details">
                                    <h1 className="itemTitle">{user.metadata.fullname}</h1>
                                    <div className="detailItem">
                                        <span className="itemKey">Email:</span>
                                        <span className="itemValue">{user.email}</span>
                                    </div>
                                    <div className="detailItem">
                                        <span className="itemKey">Phone:</span>
                                        <span className="itemValue">{user.metadata.mobilenumber}</span>
                                    </div>
                                    <div className="detailItem">
                                        <span className="itemKey">Plan:</span>
                                        <span className="itemValue">
                                            {user.subscription.name}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>



    );
};

export default Profile;